import React, { useEffect, useState } from "react";
import moment from "moment";
import api from "../../../../services/api";
import consts from "../../../../consts";
import HeaderLogadoColaborador from "../../../../components/common/Authenticated/Colaborador/Header/HeaderLogadoColaborador";
import LoadingComponent from "../../../../components/common/LoadingComponent";
import BottomMenuColaborador from "../../../../components/common/Authenticated/Colaborador/Menu/Menu";

function HomeColaborador() {
  const usuarioStorage = JSON.parse(localStorage.getItem("usuario")) || {};
  const token = localStorage.getItem("token");

  const [proximoAgendamento, setProximoAgendamento] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProximoAgendamento = async () => {
      try {
        const { data } = await api.post(
          `/agendamento/filter/proximo/${usuarioStorage._id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (!data.error && data.proximoAgendamento) {
          setProximoAgendamento(data.proximoAgendamento);
        }
      } catch (err) {
        console.error("Erro ao buscar próximo agendamento:", err);
      } finally {
        setLoading(false);
      }
    };

    if (usuarioStorage._id) fetchProximoAgendamento();
  }, [usuarioStorage._id, token]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-white">
        <LoadingComponent />
        <h2 className="text-xl font-bold mb-2">Só um instante...</h2>
        <p>Estamos carregando seu painel...</p>
      </div>
    );
  }

  const statusStyle =
    proximoAgendamento?.status === "Agendada"
      ? "bg-[#003D42]"
      : "bg-[#d9534f]";

  return (
    <>
      <HeaderLogadoColaborador />
      <div className="p-5 space-y-1 bg-white min-h-svh">
        <div className="mb-6">
          <h1 className="text-3xl font-bold">
            Olá,{" "}
            <span className="text-[#003D42]">
              {usuarioStorage?.nome?.split(" ")[0] || "Colaborador"}
            </span>
            !
          </h1>
          <h2 className="text-xl text-gray-600 mt-2">Painel de informações</h2>
        </div>

        {/* Card da próxima consulta */}
        { proximoAgendamento != null ? (<div className="bg-white rounded-xl shadow-md p-6 max-w-md">
          <h3 className="text-lg font-bold text-[#003D42] mb-4">
            Próxima Consulta
          </h3>

          <div className="flex justify-between mb-2">
            <span className="font-medium text-gray-600">Cliente:</span>
            <span className="font-semibold text-gray-800">
              {proximoAgendamento?.cliente || "-"}
            </span>
          </div>

          <div className="flex justify-between mb-2">
            <span className="font-medium text-gray-600">Serviço:</span>
            <span className="font-semibold text-gray-800">
              {proximoAgendamento?.servico || "-"}
            </span>
          </div>

          <div className="flex justify-between mb-2">
            <span className="font-medium text-gray-600">Data:</span>
            <span className="font-semibold text-gray-800">
              {proximoAgendamento?.data
                ? moment(proximoAgendamento.data).format("DD/MM/YYYY")
                : "-"}
            </span>
          </div>

          <div className="flex justify-between mb-4">
            <span className="font-medium text-gray-600">Horário:</span>
            <span className="font-semibold text-gray-800">
              {proximoAgendamento?.intervaloAtendimento || "-"}
            </span>
          </div>

          <span
            className={`text-white font-bold text-sm px-4 py-1 rounded-full ${statusStyle}`}
          >
            {proximoAgendamento?.status || "-"}
          </span>
        </div>) : "Você não tem um próximo agendamento no momento. Assim que houver um novo, ele aparecerá aqui."}
        
      </div>
      <BottomMenuColaborador />
    </>
  );
}

export default HomeColaborador;
